export default "__VITE_ASSET__c8a5c3a9__"